import { Controller } from "@hotwired/stimulus"

// Inline editor for class-template coach slots. The form on the show page
// holds the current slot rows + an empty-row template; this controller
// clones the template on "Add slot", marks rows for destroy on Remove,
// and reveals the Save button the moment the form is dirty so the
// coordinator knows the change is unpersisted.
//
// Sibling to nested_rows_controller — they do the same thing for
// holidays — but this one bundles the dirty-tracking save-button reveal
// so we don't have to stack two controllers on the same element.
export default class extends Controller {
  static targets = [ "row", "anchor", "save" ]
  static values  = { template: String }

  declare readonly anchorTarget: HTMLElement
  declare readonly saveTarget:   HTMLElement
  declare readonly hasSaveTarget: boolean
  declare readonly templateValue: string

  private readonly markDirty = () => {
    if (this.hasSaveTarget) this.saveTarget.hidden = false
  }

  connect() {
    // Any dropdown change anywhere in the form should reveal Save.
    this.element.addEventListener("change", this.markDirty)
  }

  disconnect() {
    this.element.removeEventListener("change", this.markDirty)
  }

  addRow(event: Event) {
    event.preventDefault()
    const html = this.templateValue.replace(/NEW_RECORD/g, Date.now().toString())
    this.anchorTarget.insertAdjacentHTML("beforebegin", html)
    this.markDirty()
  }

  removeRow(event: Event) {
    event.preventDefault()
    const button = event.currentTarget as HTMLElement
    const row    = button.closest('[data-class-template-slots-target="row"]') as HTMLElement | null
    if (!row) return

    const destroy = row.querySelector<HTMLInputElement>('[data-class-template-slots-target="destroy"]')
    if (destroy && destroy.previousElementSibling instanceof HTMLInputElement &&
        destroy.previousElementSibling.name.endsWith("[id]")) {
      // Persisted row: mark for destruction, hide from view so nested
      // attributes can pick it up on save.
      destroy.value = "1"
      row.style.display = "none"
    } else {
      // Unsaved row: just yank it from the DOM.
      row.remove()
    }
    this.markDirty()
  }
}
